import { UserBadge } from "./user";

export interface Comment {
  id: string;
  comment: string;
  resourceId: string;
  clientId: string;
  userId: string;
  userName: string;
  creationDate: number;
  rating: number;
  status: Status;
  parentId: string;
  nestedComments: Comment[];
  likes: number;
  dislikes: number;
  sortNum: number;
  userVoted: string[];
  commentPicture: UserBadge;
}

export enum Status {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  MODERATED = 'MODERATED',
}

export const MAX_COMMENT_LENGTH = 1024;
